// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-customer-settings .fi-customer-settings-content {
  padding: 5px 10px;
}
.fi-customer-settings .fi-customer-settings-block {
  margin: 5px 10px;
  float: left;
  width: 280px;
  height: 330px;
  padding: 15px !important;
}
.fi-customer-settings .fi-customer-settings-block-highlight {
  background-color: var(--branded-color-003);
}
.fi-customer-settings .fi-customer-settings-block-head {
  color: var(--fi-color-default);
}
.fi-customer-settings .fi-customer-settings-block-content {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/appearance/customer-settings/customer-settings.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR;AAGI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;AADR;AAII;EACI,0CAAA;AAFR;AAKI;EACI,8BAAA;AAHR;AAMI;EACI,gBAAA;AAJR","sourcesContent":[".fi-customer-settings {\r\n    .fi-customer-settings-content {\r\n        padding: 5px 10px;\r\n    }\r\n\r\n    .fi-customer-settings-block {\r\n        margin: 5px 10px;\r\n        float: left;\r\n        width: 280px;\r\n        height: 330px;\r\n        padding: 15px !important;\r\n    }\r\n\r\n    .fi-customer-settings-block-highlight {\r\n        background-color: var(--branded-color-003);\r\n    }\r\n\r\n    .fi-customer-settings-block-head {\r\n        color: var(--fi-color-default);\r\n    }\r\n\r\n    .fi-customer-settings-block-content {\r\n        margin-top: 10px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
